import { useMemo } from 'react';

interface ColumnVirtualizerParams {
  scrollLeft: number;
  containerWidth: number;
  columnWidth: number;
  totalColumnCount: number;
  bufferSize?: number;
}

interface ColumnVirtualizerResult {
  firstVisibleIndex: number;
  lastVisibleIndex: number;
  totalWidth: number;
}

export function useColumnVirtualizer({
  scrollLeft,
  containerWidth,
  columnWidth,
  totalColumnCount,
  bufferSize = 4,
}: ColumnVirtualizerParams): ColumnVirtualizerResult {
  return useMemo(
    () => getVisibleRange({ scrollLeft, containerWidth, columnWidth, totalColumnCount, bufferSize }),
    [scrollLeft, containerWidth, columnWidth, totalColumnCount, bufferSize],
  );
}

export function getVisibleRange({
  scrollLeft,
  containerWidth,
  columnWidth,
  totalColumnCount,
  bufferSize = 4,
}: ColumnVirtualizerParams): ColumnVirtualizerResult {
  const totalWidth = columnWidth * totalColumnCount;

  if (totalColumnCount === 0 || columnWidth === 0) {
    return { firstVisibleIndex: 0, lastVisibleIndex: -1, totalWidth };
  }

  const firstVisible = Math.floor(scrollLeft / columnWidth);
  const lastVisible = Math.floor((scrollLeft + containerWidth - 1) / columnWidth);

  const firstVisibleIndex = Math.max(0, firstVisible - bufferSize);
  const lastVisibleIndex = Math.min(totalColumnCount - 1, lastVisible + bufferSize);

  return { firstVisibleIndex, lastVisibleIndex, totalWidth };
}
